import { useRef } from 'react';
import HeiGrid from '../../../../Common/components/HeiGrid/HeiGrid';
import usePageTitle from '../../../../Common/hooks/usePageTitle';
import { SettingsKeys } from '../../../../Common/models/storageSettingsKeys';
import { defaultSorting } from '../../api/models/defaultSorting';
import { useToolsProjectsGrid } from '../../hooks/useToolsProjectsGrid';
import styles from '../../views/ProjectList.module.scss';
import { getColumns } from '../MyProjectsGrid/getMyProjectsGridColumns';

const ToolProjectsGrid = () => {
    usePageTitle('Tool Projects');

    const { fetchGridData } = useToolsProjectsGrid();
    const callForceRefresh = useRef(null);
    const columns = getColumns();

    return (
        <div className={styles.view}>
            <HeiGrid
                columns={columns}
                fetchGridData={fetchGridData}
                searchPlaceholder='Search project name, team members, cost center'
                defaultSorting={defaultSorting}
                refFunction={callForceRefresh}
                storageSettingsKey={SettingsKeys.OpcoProjectsGrid}
            />
        </div>
    );
};

export default ToolProjectsGrid;
